import { render } from "./form_list.vue?vue&type=template&id=8c2353be&scoped=true"
import script from "./form_list.vue?vue&type=script&lang=js"
export * from "./form_list.vue?vue&type=script&lang=js"

import "./form_list.vue?vue&type=style&index=0&id=8c2353be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2353be"]])

export default __exports__